module.exports = __webpack_public_path__ + "static/media/device-info-en.d8e13ee4.png";